var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user && !_vm.user.lexoffice_connected)?_c('ConnectLexoffice'):_vm._e(),_c('Tracks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }